var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(_vm.type===1)?_c('div',{staticClass:"loading-gif"}):(_vm.type===2)?_c('div',{staticClass:"loading-gif2"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }